import React from 'react';
import { Button, Icon } from '@mui/material';

const PageStichting: React.FC = () => {
  return (
    <>
      <header className="page-header container">
        <h1>Over Stichting Mijn Aansluiting</h1>
        <p className="header-sub-title">
          Mijn Aansluiting is een samenwerkingsverband van netbeheerders die het aanvragen en realiseren van aansluitingen op nutsvoorzieningen in heel Nederland efficiënter en klantvriendelijker willen organiseren. 
          Het gaat om de aanleg van en het aansluiten op de ondergrondse infrastructuur, zoals elektriciteit, water, gas, stadswarmte, media (zoals televisie, internet en telefoon) en in beperkt gebied ook riool.
        </p>

        <Button
            variant="contained"
            color="secondary"
            onClick={() => window.open('https://stichting.mijnaansluiting.nl', '_blank', 'noopener,noreferrer')}
          >
            Lees meer over Stichting Mijn Aansluiting
            <Icon>chevron_right</Icon>
          </Button>
      </header>
    </>
  );
};

export default PageStichting;